import { useTranslation } from "react-i18next";
import type { CountryData, PhoneInputProps } from "react-phone-input-2";
import PhoneInput from "react-phone-input-2";
import styled from "styled-components";

import "react-phone-input-2/lib/plain.css";

const AVAILABLE_COUNTRY_CODES = ["se", "gb", "us"];

interface Props extends PhoneInputProps {
  country: string | number | undefined;
  value: string | null | undefined;
  autoFocus?: boolean;
  onChange: (
    value: string,
    data: CountryData,
    event: React.ChangeEvent<HTMLInputElement>,
    formattedValue: string
  ) => void;
}

export const PhoneNumberInput: React.VFC<Props> = ({ country, autoFocus, ...props }) => {
  const { t } = useTranslation();

  return (
    <StyledPhoneInput
      disableCountryGuess
      countryCodeEditable={false}
      country={country}
      onlyCountries={AVAILABLE_COUNTRY_CODES}
      masks={{ se: ".. ... .. .." }}
      inputProps={{
        name: "phone_number",
        required: true,
        autoFocus,
      }}
      placeholder={t("form.phone_number")}
      {...props}
    />
  );
};

export const StyledPhoneInput = styled(PhoneInput)`
  margin-bottom: 12px;

  .form-control {
    height: 42px;
    width: 100%;
    padding-left: 42px;
    font-size: 18px;
    line-height: 42px;

    color: ${props => props.theme.colors.base};
    border-color: ${props => props.theme.colors.redesign.db30};
    border-width: 1px;

    &:focus {
      border-color: ${props => props.theme.colors.redesign.b100};
      border-width: 2px;
    }

    &::placeholder {
      color: ${props => props.theme.colors.base};
      opacity: 0.4;
    }
  }

  .flag-dropdown {
    border: none;
    background-color: transparent;
  }

  .flag-dropdown.open {
    background: none;

    .selected-flag {
      background: none;
    }
  }

  .selected-flag {
    padding: 0 12px 0 12px;
    background: none;

    &:hover {
      background: none;
    }
  }
`;
